(function () {

    angular.module('tmx-app').factory('LeadService', ['tmxResource',
        function LeadService(tmxResource) {
            var Lead = tmxResource("LeadManagement");
            

            //#region ================= Exported functions====================== 
            Lead.GetAllRequests = function () {
                return Lead.all();
            }

            Lead.ConvertLeadToApplication = function(data){
                return  Lead.getByAction("ConvertLeadToApplication", false, 'put',data);
            }


            //#endregion

            return Lead;

        }]);
})();